import emailjs from "@emailjs/browser";
import { EMAIL_JS_CONFIG } from "../config/email-js";

export const useEmailJs = () => {
  const sendConfirmationEmailToHR = async (
    jobTitle: string,
    name: string,
    lastName: string
  ) => {
    const response = await emailjs.send(
      EMAIL_JS_CONFIG.service,
      EMAIL_JS_CONFIG.template,
      {
        to_email: EMAIL_JS_CONFIG.to_email,
        lastName: lastName,
        name: name,
        jobTitle: jobTitle,
      },
      EMAIL_JS_CONFIG.publicToken // Usar publicToken en el browser
    );
    return response;
  };

  return { sendConfirmationEmailToHR };
};
